import React from "react";
import {
  Datagrid,
  EditButton,
  FunctionField,
  Button,
  List,
  TextField,
  DateField,
  SelectField,
  useDataProvider,
  useRefresh,
  useNotify,
  ShowButton,
  DeleteWithConfirmButton,
} from "react-admin";
import DoDisturbOnIcon from "@mui/icons-material/DoDisturbOn";
import DoDisturbOffIcon from "@mui/icons-material/DoDisturbOff";
import { EmptyList } from "common/components";
import { dateOptions, languageChoices } from "utils/options";
import { titleFilter } from "../Partials/Filters";
const ISHIDDEN = "visibility";
const ListNews = () => {
  const dataProvider = useDataProvider();
  const refresh = useRefresh();
  const notify = useNotify();
  return (
    <List
      hasCreate
      exporter={false}
      sort={{ field: "id", order: "DESC" }}
      filters={titleFilter}
    >
      <Datagrid
        bulkActionButtons={false}
        empty={<EmptyList />}
      >
        <TextField
          label="№"
          source="id"
          sortable={false}
        />
        <TextField
          label="Заглавие"
          source="title"
          sortable={false}
        />
        <SelectField
          label="Език"
          source="language"
          choices={languageChoices}
        />
        <DateField
          label="За дата"
          source="starting_on"
          locales={"bg"}
          options={dateOptions}
          sortable={false}
        />
        <DateField
          label="До дата"
          source="ending_on"
          locales={"bg"}
          options={dateOptions}
          sortable={false}
        />
        <DateField
          label="Дата на публикуване"
          source="date_beginning"
          locales={"bg"}
          options={dateOptions}
          sortable={false}
        />
        <FunctionField
          label=""
          render={record =>
            `${record.is_hidden}` === "true" ? (
              <div style={{ display: "flex", alignItems: "center" }}>
                <DoDisturbOffIcon style={{ color: "#da291c", fontSize: "18px" }} />
                <Button
                  label="Покажи"
                  onClick={() => {
                    return dataProvider
                      .customRequest(`news/${record.id}/${ISHIDDEN}`, { id: record.id, is_hidden: false }, "PUT")
                      .then(() => {
                        refresh();
                        notify("Новините са обновени!", { type: "success" });
                      })
                      .catch(error => {
                        notify("Новините не са обновени!", { type: "error" });
                        refresh();
                      });
                  }}
                />
              </div>
            ) : (
              <div style={{ display: "flex", alignItems: "center" }}>
                <DoDisturbOnIcon style={{ color: "#da291c", fontSize: "18px" }} />
                <Button
                  label="Скрий"
                  color="error"
                  onClick={() => {
                    return dataProvider
                      .customRequest(`news/${record.id}/${ISHIDDEN}`, { id: record.id, is_hidden: true }, "PUT")
                      .then(() => {
                        refresh();
                        notify("Новините са обновени!", { type: "success" });
                      })
                      .catch(error => {
                        notify("Новините не са обновени!", { type: "error" });
                        refresh();
                      });
                  }}
                />
              </div>
            )
          }
        />
        <ShowButton />
        <EditButton />
        <DeleteWithConfirmButton />
      </Datagrid>
    </List>
  );
};

export default ListNews;
